import React, { useEffect, useState, useRef } from 'react';
import './changePassword.scss';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import 'primeicons/primeicons.css';
import './index.scss';
import { useFormInput } from './hooks';
import { Password } from 'primereact/password'
import { Button } from 'primereact/button';
import 'primeflex/primeflex.scss';
import { Toast } from 'primereact/toast';
import { authenticationService } from './services/';

const localizationDefault =
{
    "enterPassword" : "Şifre giriniz.",
    "successChangePassword": "Şifreniz başarı ile değiştirildi.",
    "somethingWentWrong": "Beklenmeyen bir hata oluştu!",
    "labelChangePassword": "Şifre değiştir",
    "labelAtLeast6Chars": "En az 6 karakter içermelidir.",
    "labelAtLeast1Number": "En az 1 rakam içermelidir.",
    "labelAtLeast1Uppercase": "En az 1 büyük harf içermelidir.",
    "labelAtLeast1Lowercase": "En az 1 küçük harf içermelidir.",
    "labelAtLeast1SpecialChar": "En az 1 özel karakter içermelidir.",
    "labelMatchPasswords": "Şifreler uyuşmalıdır.",
    "labelEnterPassword": "Şifreyi giriniz.",
    "labelEnterPasswordAgain": "Şifreyi tekrar giriniz.",
    "labelSave": "Kaydet",
    "labelCancel": "İptal"
}

export const ChangePassword = (props) => {

    const token = window.location.search.split('token=')[1];

    const [isLoading, setIsLoading] = useState(false);

    const password = useFormInput("");

    const passwordRepeat = useFormInput("");

    const toast = useRef(null);

    const localization = {...localizationDefault, ...props.localization};

    const passwordControl = () => {

        let ucase = new RegExp("[A-Z]+");

        let lcase = new RegExp("[a-z]+");

        let num = new RegExp("[0-9]+");

        let specialChar = /[.?#*!%+^/&$(){}|-]/;

        if (specialChar.test(password.value) &&
            password.value == passwordRepeat.value &&
            passwordRepeat.value.length > 0 &&
            password.value.length >= 6 &&
            ucase.test(password.value) &&
            lcase.test(password.value) &&
            num.test(password.value)) {

            document.querySelector(".p-button").disabled = false;
        }
        else {

            document.querySelector(".p-button").disabled = true;
        }

        if (ucase.test(password.value)) {

            document.querySelector("#bs-ucase .pi").classList.add("pi-check")

            document.querySelector("#bs-ucase .pi").classList.remove("pi-times")

            document.querySelector("#bs-ucase span").classList.add("bs-text-line-through")
        }
        else {

            document.querySelector("#bs-ucase .pi").classList.remove("pi-check")

            document.querySelector("#bs-ucase .pi").classList.add("pi-times")

            document.querySelector("#bs-ucase span").classList.remove("bs-text-line-through")
        }

        if (lcase.test(password.value)) {

            document.querySelector("#bs-lcase .pi").classList.add("pi-check")

            document.querySelector("#bs-lcase .pi").classList.remove("pi-times")

            document.querySelector("#bs-lcase span").classList.add("bs-text-line-through")

        } else {

            document.querySelector("#bs-lcase .pi").classList.remove("pi-check")

            document.querySelector("#bs-lcase .pi").classList.add("pi-times")

            document.querySelector("#bs-lcase span").classList.remove("bs-text-line-through")
        }

        if (num.test(password.value)) {

            document.querySelector("#bs-num .pi").classList.add("pi-check")

            document.querySelector("#bs-num .pi").classList.remove("pi-times")

            document.querySelector("#bs-num span").classList.add("bs-text-line-through")

        } else {

            document.querySelector("#bs-num .pi").classList.remove("pi-check")

            document.querySelector("#bs-num .pi").classList.add("pi-times")

            document.querySelector("#bs-num span").classList.remove("bs-text-line-through")
        }

        if (password.value.length >= 6) {

            document.querySelector("#bs-password-length .pi").classList.add("pi-check")

            document.querySelector("#bs-password-length .pi").classList.remove("pi-times")

            document.querySelector("#bs-password-length span").
                classList.add("bs-text-line-through")

        } else {

            document.querySelector("#bs-password-length .pi").classList.remove("pi-check")

            document.querySelector("#bs-password-length .pi").classList.add("pi-times")

            document.querySelector("#bs-password-length span").classList.
                remove("bs-text-line-through")
        }

        if (specialChar.test(password.value)) {

            document.querySelector("#bs-special-char .pi").classList.add("pi-check")

            document.querySelector("#bs-special-char .pi").classList.remove("pi-times")

            document.querySelector("#bs-special-char span").classList.add("bs-text-line-through")

        } else {

            document.querySelector("#bs-special-char .pi").classList.remove("pi-check")

            document.querySelector("#bs-special-char .pi").classList.add("pi-times")

            document.querySelector("#bs-special-char span").classList.
                remove("bs-text-line-through")
        }
        if (password.value == passwordRepeat.value && passwordRepeat.value.length > 0) {

            document.querySelector("#bs-compare-password .pi").classList.add("pi-check")

            document.querySelector("#bs-compare-password .pi").classList.remove("pi-times")

            document.querySelector("#bs-compare-password span").classList.
                add("bs-text-line-through")

        } else {

            document.querySelector("#bs-compare-password .pi").classList.remove("pi-check")

            document.querySelector("#bs-compare-password .pi").classList.add("pi-times")

            document.querySelector("#bs-compare-password span").classList.
                remove("bs-text-line-through")
        }
    }

    const changePassword = () => {

        if (props.onClick) {

            return props.onClick(password.value, setIsLoading);
        }

        if (!password.value) {

            toast.current.show({
                severity: 'info',
                detail: localization.enterPassword,
                life: 3000
            });

            return;
        }

        setIsLoading(true);

        if (props.onRequest) {

            return props.onRequest(password.value, setIsLoading);
        }

        authenticationService.changePassword({ token, password: password.value },
            props.url).
            then(response => {

                if (props.onPromise) {

                    return props.onPromise(response);
                }

                if (!response.success) {

                    toast.current.show({
                        severity: 'error',
                        detail: response.message,
                        life: 5000
                    });

                    return;
                }

                if (props.onSuccess) {

                    props.onSuccess(response.data);
                }
                else {

                    toast.current.show({
                        severity: 'success',
                        detail: localization.successChangePassword,
                        life: 3000
                    });

                    setTimeout(() => {

                        window.location.href = "/";

                    }, 3000);
                }
            }).
            catch(ex => {

                console.error(ex);

                toast.current.show({
                    severity: 'error',
                    detail: localization.somethingWentWrong,
                    life: 3000
                });

            }).finally(() => {

                setIsLoading(false);
            })
    }

    return (
        <>
            <Toast ref={toast} />
            <div className='bs-change-password'>
                <img className='bs-logo' src={props.logo}></img>
                <div class="grid">
                    <div class="col">
                        <h1>{localization.labelChangePassword}</h1>
                        <p id='bs-password-length'><i className="pi pi-times" style={{ color: 'red' }}></i> <span>{localization.labelAtLeast6Chars}</span> </p>
                        <p id='bs-num'><i className="pi pi-times" style={{ color: 'red' }}></i> <span>{localization.labelAtLeast1Number}</span></p>
                        <p id='bs-ucase'><i className="pi pi-times" style={{ color: 'red' }}></i> <span>{localization.labelAtLeast1Uppercase}</span></p>
                        <p id='bs-lcase'><i className="pi pi-times" style={{ color: 'red' }}></i><span>{localization.labelAtLeast1Lowercase}</span></p>
                        <p id='bs-special-char'><i className="pi pi-times" style={{ color: 'red' }}></i> <span>{localization.labelAtLeast1SpecialChar}</span></p>
                        <p id='bs-compare-password'><i className="pi pi-times" style={{ color: 'red' }}></i> <span>{localization.labelMatchPasswords}</span></p>
                    </div>
                    <div class="col" style={{ marginLeft: 15 }}>
                        <div className="p-inputgroup bs-inputgroup">
                            <Password placeholder={localization.labelEnterPassword}
                                autoFocus
                                toggleMask
                                style={{ marginTop: '10px' }}
                                feedback={false}
                                value={password.value}
                                onChange={password.onChange}
                                onKeyUp={() => passwordControl()}
                                onKeyDown={(e) => {

                                    if (e.key === 'Enter') {

                                        changePassword();
                                    }
                                }}
                            />
                        </div>

                        <div className="p-inputgroup bs-inputgroup">
                            <Password placeholder={localization.labelEnterPasswordAgain}
                                toggleMask
                                feedback={false}
                                value={passwordRepeat.value}
                                onChange={passwordRepeat.onChange}
                                onKeyUp={() => passwordControl()}
                                onKeyDown={(e) => {

                                    if (e.key === 'Enter') {

                                        changePassword();
                                    }
                                }}
                            />
                        </div>
                        <Button loading={isLoading} className='bs-btn' onClick={() => changePassword()} label={localization.labelSave} />
                        <Button label={localization.labelCancel} severity="secondary" text raised />
                    </div>
                </div>

            </div>
        </>
    );
}

export default ChangePassword; 